import { Star } from "lucide-react";

export function Marquee({ items = [] }) {
  if (!items.length) return null;
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="px-6 text-sm font-bold text-navy">{item}</span>
          <Star className="h-4 w-4 shrink-0 fill-amber-400 text-amber-400" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-line bg-white py-3.5"
    >
      <div className="flex w-max animate-marquee">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
